export default __webpack_public_path__ + "static/media/twitter.f4680616.png";